import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ILead, IDropdown } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { FileUpload } from "primereact/fileupload";
import { JVDropdown } from "../../shared/JVDropdown";
import { useNavigate } from "react-router-dom";
const schema = yup.object({
    assignedToId: yup
        .number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue == null ? null : value
        ),
    statusId: yup
        .number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue == null ? null : value
        )
        .test(
            "status-required",
            "Status is required",
            function (value) {
                const { assignedToId } = this.parent;
                if (assignedToId && assignedToId > 0) {
                    return value != null && value > 0;
                }

                return true;
            }
        ),
    sourceId: yup
        .number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue == null ? null : value
        )
        .test(
            "source-required",
            "Source is required",
            function (value) {
                const { assignedToId } = this.parent;
                if (assignedToId && assignedToId > 0) {
                    return value != null && value > 0;
                }
                return true;
            }
        ),
});


interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const BulkUploadForm = (props: Iprops) => {

    const navigate = useNavigate();
    const [users, setUsers] = useState<IDropdown[]>();
    const [resumeFile, setResumeFile] = useState<File | null | any>(null);
    const [submitting, setSubmitting] = useState(false);
    const [statuses, setStatuses] = useState<IDropdown[]>([]);
    const [sources, setSources] = useState<IDropdown[]>([]);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<ILead>({
        resolver: yupResolver(schema),
          shouldFocusError: false,   // <-- ADD THIS
        defaultValues: {
            assignedToId: null,
            statusId: null,
            sourceId: null,
        } as any,
    });
    useEffect(() => {
        loadUsers();
        loadStatuses();
        loadSources();
    }, []);


    const loadStatuses = async () => {
        const response = await Fetch("status/dropdown", "GET", null, null, null);
        if (response) {
            const statusList = await response.json();
           setStatuses([{ id: null, name: "--Select Status--" }, ...statusList]);
        }
    }

    const loadSources = async () => {
        const response = await Fetch("source/dropdown", "GET", null, null, null);
        if (response) {
            const sourceList = await response.json();
            setSources([{ id: null, name: "--Select Source--" }, ...sourceList]);
        }
    }

    const loadUsers = async () => {
        const response = await Fetch("user/dropdown", "GET", null, null, null);
        if (response) {
            setUsers([{ id: null, name: "--Select User--" }, ...(await response.json())]);
        }
    }
   const saveToDB = async (data: any) => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setSubmitting(true);
    const formData = new FormData();
    formData.append("file", resumeFile);
    const payload = {
        assignedToId: data.assignedToId,
        statusId: data.statusId,
        sourceId: data.sourceId
    };
    formData.append("payload", JSON.stringify(payload));
    const params = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${
                JSON.parse(sessionStorage.getItem("auth") + "")?.token
            }`
        },
        body: formData
    };
    const response = await fetch(
        `${baseUrl}Contact/importContact?timeZone=${encodeURIComponent(timezone)}`,
        params
    );

    if (response.ok) {
        const msg = await response.json();

        props.hideDialog();

        props.toast.current.show({
            severity: "info",
            summary: "Bulk Upload Processing",
            detail: (
                <span>
                    {msg.message ||
                        "Your file is being processed. This may take a few minutes."}{" "}
                    If you want to see progress,{" "}
                    <span
                        style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                            color: "#2196F3",
                            fontWeight: "bold"
                        }}
                        onClick={() => {
                            props.toast.current.clear();
                            navigate("/bulkUpload");
                        }}
                    >
                        click here
                    </span>
                    .
                </span>
            ),
            life: 15000
        });

        props.reloadData();
    } else {
        let errorMessage = "Upload failed";

        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (err) {
            console.error("Error parsing error response", err);
        }

        props.toast.current.show({
            severity: "error",
            detail: errorMessage,
            life: 5000
        });
    }

    setSubmitting(false);
};


    const onHide = () => {
        props.hideDialog();
        //reset({});
        reset({
            assignedToId: null,
            statusId: null,
            sourceId: null,
        } as any);
        setResumeFile(null);
    }

    function onSubmit(data: ILead) {
        if (resumeFile == null) {
            props.toast.current.show({ severity: 'error', detail: "Please Upload Excel First!", life: 3000 });

        } else {
            saveToDB(data);
        }
    }
    const onUpload = (event: any) => {
        const file = event.files[0];
        const allowedExtensions = [".xls", ".xlsx"];
        const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();

        if (!allowedExtensions.includes(ext)) {
            props.toast.current.show({ severity: 'error', detail: "Please upload a valid Excel file (.xls or .xlsx)." });
            event.options.clear();
            return;
        }

        if (file.size > 1024 * 1024 * 5) { // 5MB
            props.toast.current.show({ severity: 'error', detail: "File size should be less than 5 MB." });
            event.options.clear();
            return;
        }

        setResumeFile(file);
        props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Excel file selected", life: 3000 });

        event.options.clear();
    };


    const assignedToId = watch("assignedToId");

    return (
        <Dialog visible={props.open} style={{ width: '400px' }} header="Bulk Upload" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown column={1} label="Assigned To" control={control} options={users} optionLabel="name" optionValue="id" name="assignedToId" placeholder="Select" error={errors.assignedToId?.message} />
                {Number(assignedToId) > 0 && (
    <>
        <JVDropdown
            column={1}
            label="Status"
            control={control}
            options={statuses}
            optionLabel="name"
            optionValue="id"
            name="statusId"
            placeholder="Select Status"
            error={errors.statusId?.message}
        />

        <JVDropdown
            column={1}
            label="Source"
            control={control}
            options={sources}
            optionLabel="name"
            optionValue="id"
            name="sourceId"
            placeholder="Select Source"
            error={errors.sourceId?.message}
        />
    </>
)}
                <div className="card flex justify-content-center ml-3 mt-3">
                    <FileUpload chooseLabel="Choose Excel File" mode="basic" name="file"
                        accept=".xls,.xlsx"
                        customUpload
                        uploadHandler={onUpload}
                        auto
                    />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button loading={submitting} style={{ width: '100px' }} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}